import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface MasterOption {
  code: string;
  label: string;
  extra?: string;
}

export type MasterDataSearchParams = {
  search?: string;
  page?: number;
  size?: number;
};

export const masterDataApi = {
  countries: (params?: MasterDataSearchParams) =>
    unwrap(api.get<ApiResponse<MasterOption[]>>('/v1/master-data/countries', { params })),

  getCountry: (code: string) =>
    unwrap(api.get<ApiResponse<MasterOption>>(`/v1/master-data/countries/${encodeURIComponent(code)}`)),

  currencies: (params?: MasterDataSearchParams) =>
    unwrap(api.get<ApiResponse<MasterOption[]>>('/v1/master-data/currencies', { params })),

  getCurrency: (code: string) =>
    unwrap(api.get<ApiResponse<MasterOption>>(`/v1/master-data/currencies/${encodeURIComponent(code)}`)),

  timezones: (params?: MasterDataSearchParams) =>
    unwrap(api.get<ApiResponse<MasterOption[]>>('/v1/master-data/timezones', { params })),

  getTimezone: (zoneId: string) =>
    unwrap(
      api.get<ApiResponse<MasterOption>>('/v1/master-data/timezones/lookup', {
        params: { zoneId },
      }),
    ),

  taxModes: () => unwrap(api.get<ApiResponse<MasterOption[]>>('/v1/master-data/tax-modes')),

  all: () =>
    unwrap(
      api.get<
        ApiResponse<{
          countries: MasterOption[];
          currencies: MasterOption[];
          timezones: MasterOption[];
          taxModes: MasterOption[];
        }>
      >('/v1/master-data/all'),
    ),

  addCountry: (code: string, name: string) =>
    unwrap(
      api.post<ApiResponse<MasterOption>>('/v1/master-data/countries', null, {
        params: { code, name },
      }),
    ),
  addCurrency: (code: string, name: string, symbol?: string) =>
    unwrap(
      api.post<ApiResponse<MasterOption>>('/v1/master-data/currencies', null, {
        params: { code, name, symbol },
      }),
    ),
  addTimezone: (zoneId: string, label: string) =>
    unwrap(
      api.post<ApiResponse<MasterOption>>('/v1/master-data/timezones', null, {
        params: { zoneId, label },
      }),
    ),
  addTaxMode: (code: string, name: string) =>
    unwrap(
      api.post<ApiResponse<MasterOption>>('/v1/master-data/tax-modes', null, {
        params: { code, name },
      }),
    ),
};
